// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","container":"_112VQhlCpIcEDvn1TcRxcn _2ELtkcMpIJZ1yyH_kfj3I7"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/terms/Terms.css
// module id = 1173
// module chunks = 2